import {useNavigate, useSearchParams} from "react-router-dom";
import {regionSelector, useGetRegionQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo, useState} from "react";
import {RegionProfile} from "../../components/profile/RegionProfile/RegionProfile";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";
import {useTranslation} from "react-i18next";

type Props = {
  id?: string;
}

export const RegionProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.region", "Region") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <RegionProfilePage id={id}/>;
};

export const RegionProfilePage = (props: Props) => {
  const {id} = props;

  const [access, setAccess] = useState(false);

  const selectRegion = useMemo(() => {
    return regionSelector()
  }, []);

  const {region, isFetching, error} = useGetRegionQuery(access ? (id ?? skipToken) : skipToken, {
    selectFromResult: (result) => ({
      region: selectRegion(result),
      isFetching: result.isFetching,
      error: result.error,
    })
  });

  return (
    <EntityProfilePage
      permissions={["region_view"]}
      entity={region}
      isLoading={isFetching}
      error={error}
      onAccess={setAccess}>
      {(entity) => (
        <RegionProfile region={entity}/>
      )}
    </EntityProfilePage>
  )
};
